import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class NumberDisplayComponent extends React.Component {
    render() {
        const { isCodePromo, partners, PARTNER, MERCHANT, REDUCTION } = this.props;
        let texte;
        const nombre = isCodePromo
            ? partners.reduce((res, curr) => res + curr.couponCount, 0)
            : partners.length;
        const s = nombre > 1 ? 's' : '';
        if (isCodePromo) {
            texte = `${REDUCTION.CODE}${s} ${REDUCTION.DISCOUNTOF}`;
        } else {
            texte = `${MERCHANT}${s} ${PARTNER}${s}`;
        }
        return (
            <h2 className="nombre-partenaires">
                <span aria-live="polite" aria-atomic="true">
                    <span><strong>{nombre}</strong> {texte}</span>
                </span>
            </h2>
        );
    }
}

NumberDisplayComponent.propTypes = {
    isCodePromo: PropTypes.bool,
    partners: PropTypes.array
};

const mapStatetoProps = state => ({
    PARTNER: state.i18n.page.DIRECTORY.PARTNER,
    MERCHANT: state.i18n.page.DIRECTORY.MERCHANT,
    REDUCTION: state.i18n.page.DIRECTORY.REDUCTION
});

export default connect(mapStatetoProps)(NumberDisplayComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/NumberDisplayComponent.js